/** @public */
export type PanelWidth = number | `${number}%`;

/** @internal */
export const clamp = (min: number, value: number, max: number) => {
  return Math.max(min, Math.min(value, max));
};

const isPercentage = (value: PanelWidth): value is `${number}%` => {
  return typeof value === 'string' && value.trim().endsWith('%');
};

/** @internal */
export const convertToPx = (value: PanelWidth, containerSize: number) => {
  if (typeof value === 'number') {
    return value;
  }

  const numeric = Number.parseFloat(value);
  if (!Number.isFinite(numeric)) {
    throw Error('`value` must be finite');
  }

  if (isPercentage(value)) {
    return (numeric / 100) * containerSize;
  }

  return numeric;
};

/** @internal */
export const resolveWidthPx = (
  widthValue: PanelWidth,
  containerWidth: number,
  fallback: number,
) => {
  if (typeof widthValue === 'number') {
    return widthValue;
  }

  if (containerWidth <= 0) {
    return fallback;
  }

  return convertToPx(widthValue, containerWidth);
};

/** @internal */
export const toCssLength = (value: PanelWidth) => {
  if (typeof value === 'number') {
    return `${value}px`;
  }
  return value;
};
